<template>
  <div :class="[baseCss]">
    <time-picker @input="onInput" v-if="initialState" :segments="timePickerSegments" :color="bgColor" :color-lightness="bgColorLightness" :initial-state="initialState" />
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'DatetimePickerTime',
  mixins: [
    methods
  ],
  data () {
    return {
      selectedHour: 0,
      selectedMinute: 0,
      baseCss: this.componentBaseCss('datetime-picker-time', []),
      hours: Array.from({length: 24}, (_, value) => {
        return {value, label: value.toString().padStart(2, '0')}
      }),
      minutes: Array.from({length: 60}, (_, value) => {
        return {value, label: value.toString().padStart(2, '0')}
      }),
      initialState: null
    }
  },
  props: ['height', 'bgColor', 'bgColorLightness', 'date', 'timePickerSegments'],
  mounted () {
    this.prepareTime()
  },
  methods: {
    prepareTime () {
      const date = new Date(this.date)
      this.initialState = {
        hours: date.getHours(),
        minutes: date.getMinutes(),
        seconds: date.getSeconds(),
        'am/pm': 'am'
      }
    },
    onInput ($event) {
      this.$emit('timeinput', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/datetime-picker-time/datetime-picker-time.vue